<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle class="rds-nav-tree-node-no-children" [class.node-active]="rla.isActive">
    <a class="rds-nav-tree-node-link" [routerLink]="node.url" routerLinkActive #rla="routerLinkActive">
      <mat-icon class="node-icon">{{ node.icon }}</mat-icon>
      <span class="rds-nav-tree-node-link-text">{{ node.label }}</span>
    </a>
  </mat-tree-node>
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" [class.node-active]="rla.isActive">
      <button class="tree-toggle-button" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
        <mat-icon>
          {{ treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right' }}
        </mat-icon>
      </button>
      <a class="rds-nav-tree-node-link" [routerLink]="node.url" routerLinkActive #rla="routerLinkActive">
        <mat-icon class="node-icon">{{ node.icon }}</mat-icon>
        <span class="rds-nav-tree-node-link-text">{{ node.label }}</span>
      </a>
    </div>
    <div class="nested-tree-outlet" *ngIf="treeControl.isExpanded(node)" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
